import { createI18n } from 'vue-i18n'
import { initialLocale } from '@/lib/locale'
import en from '@/locales/en.json'
import fr from '@/locales/fr.json'

const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
})

export default i18n
